import  { Redirect } from 'react-router-dom'
const config = require('./config');

export let setUserInfo = (rememberMe, signedIn, token, userName, userGroup) => {
    try {
        if(rememberMe) {
            // Local Storage
            localStorage.setItem('microtekLabIotSignedIn', signedIn);
            localStorage.setItem('microtekLabIotToken', token);
            localStorage.setItem('microtekLabIotUserName', userName);
            localStorage.setItem('microtekLabIotUserGroup', userGroup);
            // Session Storage
            sessionStorage.setItem('microtekLabIotSignedIn', 'false');
            sessionStorage.setItem('microtekLabIotToken', '');
            sessionStorage.setItem('microtekLabIotUserName', '');
            sessionStorage.setItem('microtekLabIotUserGroup', '');
        } else {
            // Local Storage
            localStorage.setItem('microtekLabIotSignedIn', 'false');
            localStorage.setItem('microtekLabIotToken', '');
            localStorage.setItem('microtekLabIotUserName', '');
            localStorage.setItem('microtekLabIotUserGroup', '');
            // Session Storage
            sessionStorage.setItem('microtekLabIotSignedIn', signedIn);
            sessionStorage.setItem('microtekLabIotToken', token);
            sessionStorage.setItem('microtekLabIotUserName', userName);
            sessionStorage.setItem('microtekLabIotUserGroup', userGroup);
        }
    } catch (err) {
        console.log(err);
    }
}

export let signOutUser = () => {
    // Local Storage
    localStorage.setItem('microtekLabIotSignedIn', false);
    localStorage.setItem('microtekLabIotToken', '');
    localStorage.setItem('microtekLabIotUserName', '');
    localStorage.setItem('microtekLabIotUserGroup', '');
    // Session Storage
    sessionStorage.setItem('microtekLabIotSignedIn', false);
    sessionStorage.setItem('microtekLabIotToken', '');
    sessionStorage.setItem('microtekLabIotUserName', '');
    sessionStorage.setItem('microtekLabIotUserGroup', '');
}

export function getUserInfo() {
    let returnVal = {
        signedIn: false,
        token: '',
        userName: '',
        userGroup: '',
    }

    returnVal.signedIn = localStorage.getItem('microtekLabIotSignedIn');
    if((returnVal.signedIn)
    &&(returnVal.signedIn.toUpperCase() === 'TRUE')) {
        returnVal.token = localStorage.getItem('microtekLabIotToken');
        returnVal.userName = localStorage.getItem('microtekLabIotUserName');
        returnVal.userGroup = localStorage.getItem('microtekLabIotUserGroup');
    } else {
        returnVal.signedIn = sessionStorage.getItem('microtekLabIotSignedIn');
        returnVal.token = sessionStorage.getItem('microtekLabIotToken');
        returnVal.userName = sessionStorage.getItem('microtekLabIotUserName');
        returnVal.userGroup = sessionStorage.getItem('microtekLabIotUserGroup');
    }
    
    return returnVal;
}

export async function validateSignIn() {
    const requestOptions = {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.getUserInfo().token
      }
    };
    
    let resRaw = await fetch(this.getBasePath().concat('userManagement/validateSignIn'), requestOptions);
    let res = await resRaw.json();
    if(res.loginRequired) {
        this.signOutUser();
        return {error: res.error, loginRequired: true, adminRequired: false};
    } else if(res.adminRequired) {
        return {error: res.error, loginRequired: false, adminRequired: true};
    } else {
        return {error: res.error, loginRequired: false, adminRequired: false};
    }
  }

export function getBasePath() {
    // return 'http://'.concat(window.location.hostname, ':', config.apiPort, '/');
    return 'https://api.screlektroniks.com/';
}

export function redirectToError() {
    return <Redirect to='/InternalError'/>
}

export function redirectToSignIn() {
    return <Redirect to='/SignIn'/>
}

export function redirectToRestrictedContent() {
    return <Redirect to='/RestrictedContent'/>
}

export function redirectToHome() {
    return <Redirect to='/'/>
}

export function getPanelName(screenIndex) {
    let returnVal = '';
    switch(screenIndex) {
        case 0:
            returnVal = config.panelNameTrippingCurrentCharacteristic;
            break;
        case 1:
            returnVal = config.panelNameInstantaneousTripping;
            break;
        case 2:
            returnVal = config.panelNameTemperatureRise;
            break;
        case 3:
            returnVal = config.panelNameEndurance;
            break;
        case 4:
            returnVal = config.panelName28Days;
            break;
        case 5:
            returnVal = config.panelNameMcbCharacteristic;
            break;
        case 6:
            returnVal = config.panelNameRccb;
            break;
        default:
            returnVal = '';
            break;
    }
    return returnVal;
}

export function getCardHeaderClassName() {
    return 'card-header text-center';
}

export function getTestIdClassName() {
    return 'display-6 m-1 m-sm-1 m-md-2 m-lg-3 text-warning';
}

export function getFooterString() {
    return 'Copyright © '.concat(new Date().getFullYear(), ' SCR ELEKTRONIKS PRIVATE LIMITED. All Rights Reserved.');
}

export function getFooterStringTopLine() {
    return 'Copyright © '.concat(new Date().getFullYear(), ' SCR ELEKTRONIKS');
}

export function getFooterStringBottomLine() {
    return ' All Rights Reserved ';
}

export let cardBgColor = '#212529';

export let cardBorderRadius = '0%';

export let cardHrColor = '#FFFFFF';

export let cardBorderColor = '#AFAFAF';
